import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

import Background from '../_components/background';

class Hero {
    constructor() {
        this.components = document.querySelectorAll('.m-hero');

        if (this.components == null) return;

        this.components.forEach((component) => {
            this.init(component);
        });
    }

    init(component) {
        const self = this;
        const background = component.querySelector('.m-hero__background');

        if (background) {
            new Background(background);

            self.addAnimation(component, background);
        }
    }

    addAnimation(component, background) {
        ScrollTrigger.matchMedia({
            '(max-width: 959px)': function () {
                gsap.set(background, { clearProps: true });
            },
            '(min-width: 960px)': function () {
                gsap.set(background, {
                    yPercent: '-25',
                });

                gsap.to(background, {
                    ease: 'none',
                    yPercent: '25',
                    scrollTrigger: {
                        trigger: component,
                        start: 'top bottom',
                        end: 'bottom top',
                        scrub: true,
                    },
                });
            },
        });
    }
}

export default Hero;
